<!--
 * @Author: your name
 * @Date: 2020-11-08 22:39:33
 * @LastEditTime: 2020-11-13 15:36:20
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /mall-wap-vue/src/views/mine/modifyloginpass/index.vue
-->
<template>
  <div class="pass">
    <title-bar-back :title="'修改登录密码'" @back="back">
      <div class="title_right"></div>
    </title-bar-back>
    <!-- 原登录密码 -->
    <!-- <pass-filder
      :placeholder="'输入原密码'"
      :label="'原登录密码'"
      @changePass="changePassOld"
    /> -->
    <!-- 新密码 -->
    <pass-filder
      :placeholder="'6-12位数字或字母'"
      :label="'新密码'"
      @changePass="changePassNew"
    />
    <!-- 确认密码 -->
    <pass-filder
      :placeholder="'再次输入新密码'"
      :label="'确认密码'"
      @changePass="changePassConfirm"
    />
    <!-- 确定 -->
    <div
      :class="true ? 'go_btn' : 'un_btn'"
      class="font14 font_weight500 colof btn"
      @click="sure"
    >
      确定
    </div>
  </div>
</template>
<script>
const TitleBarBack = () =>
  import("@/components/TitleBarBack").then(m => m.default || m);
import PassFilder from "./components/PassFilder";
// const PassFilder = () =>
//   import("./components/PassFilder").then(m => m.default || m);
export default {
  name: "ModifyLogiunPass",
  components: {
    TitleBarBack,
    PassFilder
  },
  data() {
    return {
      oldPass: "",
      newPass: "",
      confirmPass: ""
    };
  },
  methods: {
    back() {
      this.$router.back();
    },
    sure() {
      if (this.newPass.trim().length < 6 || this.newPass.trim().length > 12) {
        this.$toast("请输入6-12位数字或字母的新密码");
        return;
      }
      if (
        this.confirmPass.trim().length < 6 ||
        this.confirmPass.trim().length > 12
      ) {
        this.$toast("请输入6-12位数字或字母的确认密码");
        return;
      }
      if (this.newPass.trim() !== this.confirmPass.trim()) {
        this.$toast("两次密码不一致");
        return;
      }
      // 修改密码 changePassword
      const params = { newPassword: this.newPass.trim() };
      this.$store
        .dispatch("mine/changePassword", { params })
        .then(() => {
          this.$toast("修改成功");
          // 调用退出登录接口清除token(用户需要重新登录)
          this.$router.go(-2);
        })
        .catch(() => {});
    },
    // changePassOld(value) {
    //   this.oldPass = value;
    //   console.log(this.oldPass);
    // },
    changePassNew(value) {
      this.newPass = value;
    },
    changePassConfirm(value) {
      this.confirmPass = value;
    }
  }
};
</script>
<style lang="less" scoped>
.title_right {
  width: 36px;
}
.pass {
  background: #fff;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  .item_item {
    background: #fff;
    padding: 14px 12px;
    line-height: 24px;
    .right_det {
      color: rgba(0, 0, 0, 0.55);
    }
    .all_right {
      color: #bf9264;
    }
    .right_go {
      // margin-top: 17px;
      width: 24px;
    }
    .right_chart {
      color: #bf9264;
    }
  }
  .btn {
    margin: 16px 12px 0;
    line-height: 40px;
    border-radius: 20px;
  }
  .un_btn {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
    opacity: 0.5;
  }
  .go_btn {
    background: linear-gradient(90deg, #e1c49d 0%, #bf9264 100%);
  }
}
</style>
